import { endOfDay, endOfHour, endOfMonth } from "date-fns/esm";

import DateRangeType from "@mapmycustomers/shared/types/range/DateRange";

import { DateRange } from "@app/enum/dashboard/dateRanges";
import { getWeekEnd } from "@app/util/dates";

const getChartPointDateRange = (date: number, dateRange: DateRange): DateRangeType => {
  const startDate = new Date(date);
  switch (dateRange) {
    case DateRange.DAY:
      return { endDate: endOfHour(startDate), startDate };
    case DateRange.MONTH:
      return { endDate: endOfDay(startDate), startDate };
    case DateRange.QUARTER:
      return { endDate: getWeekEnd(startDate), startDate };
    case DateRange.WEEK:
      return { endDate: endOfDay(startDate), startDate };
    case DateRange.YEAR:
      return { endDate: endOfMonth(startDate), startDate };
  }
};

export default getChartPointDateRange;
